module.exports = __webpack_public_path__ + "static/media/message.3aed96da.svg";